import type { CellProps, Direction, Pos, CellGridProps } from "./Cell";

/**
 *
 * @param {Direction} d
 * @returns the direction opposing {@link d}
 */
export function invertDir(d: Direction): Direction {
  switch (d) {
    case "down":
      return "up";
    case "up":
      return "down";
    case "left":
      return "right";
    case "right":
      return "left";
  }
}
/**
 *
 * @param {Direction} d
 * @param {Pos} pos staring position
 * @returns the position in direction {@link d} from {@link pos}
 */
export function applyDir(d: Direction, pos: Pos): Pos {
  let [x, y] = pos;
  switch (d) {
    case "down":
      return [x, y + 1];
    case "up":
      return [x, y - 1];
    case "left":
      return [x - 1, y];
    case "right":
      return [x + 1, y];
  }
}
/**
 *
 * @param cell
 * @param d
 * @returns whether {@link cell} is connected in direction {@link d}
 */
export function cellIsFacing(cell: CellProps, d: Direction): boolean {
  switch (cell.kind) {
    case "empty":
      return false;
    case "bridge":
    case "node":
      return true;
    case "path":
      return cell.directionA === d || cell.directionB === d;
  }
}
export type PackedGrid = {
  data: (["bridge"] | ["node", string] | [number])[];
  x: number;
  y: number;
};
/**
 *
 * @param g
 * @returns the deserialized form of {@link d}
 */
export function deserialize(g: PackedGrid): CellGridProps {
  let cells: CellProps[][] = [];
  cells = new Array(g.y);
  for (let i = 0; i < g.y; i++) cells[i] = new Array(g.x);
  let pos: Pos = [0, 0];
  for (let i of g.data) {
    let cell: CellProps;
    switch (i[0]) {
      case "bridge":
        cell = newCell();
        cell.kind = "bridge";
        cell.x = pos[0];
        cell.y = pos[1];
        pos = insertCell(cell, cells, pos, g.x, g.y);
        break;
      case "node":
        cell = newCell();
        cell.kind = "node";

        cell.colorlow = i[1];
        cell.x = pos[0];
        cell.y = pos[1];
        pos = insertCell(cell, cells, pos, g.x, g.y);
        break;
      default:
        for (let j = 0; j < i[0]; j++) {
          cell = newCell();
          cell.x = pos[0];
          cell.y = pos[1];
          pos = insertCell(cell, cells, pos, g.x, g.y);
        }
        break;
    }
  }
  return { cells, x: g.x, y: g.y };
}
/**
 *
 * @param c cell to insert
 * @param g grid to insert into
 * @param pos the position of cell to insert
 * @param maxX
 * @param maxY
 * @returns the next position  to insert into in {@link g}
 */
function insertCell(
  c: CellProps,
  g: CellProps[][],
  pos: Pos,
  maxX: number,
  maxY: number
): Pos {
  let [x, y] = pos;
  if (y === maxY) {
    return [0, y];
  }
  g[y][x] = c;
  if (x === maxX - 1) {
    return [0, y + 1];
  }
  return [x + 1, y];
}
/**
 * 
 * @returns a default Cell
 */
function newCell(): CellProps {
  return {
    kind: "empty",
    x: -1,
    y: -1,
    colorlow: "white",
    colorVert: "white",
    selected: false,
  };
}
/*
// expects num;num;(num;|[a-zA-Z+];)*
// x;y;RLE data
export function deserializeStr(s:string):PackedGrid|undefined{
    const numRegex=/[0-9]+/
    let frags=s.split(';')
    if(frags.length<3)return
    let x=Number.parseInt(frags[0])
    let y=Number.parseInt(frags[1])
    frags=frags.slice(2)
    let count=x*y
    let g:PackedGrid={x,y,data:[]}
    for(let e of frags){
        if(numRegex.test(e)){
            let n = Number.parseInt(e)
            count-=n
            g.data.push([n])
        }else{
            for(let i of e){
                count-=1
                if(i==='+')g.data.push(['bridge'])
                let col=colors.get(i)
                if(!col)return
                g.data.push(['node',col])
            }
        }
    }
    if(count>0)return
    return g
}
*/
const colors: ReadonlyMap<string, string> = new Map([
  ["r", "red"],
  ["b", "blue"],
  ["g", "green"],
  ["c", "cyan"],
  ["o", "orange"],
  ["k", "black"],
]);
